var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({staticClass:"form-input",class:{ [`input-${_vm.size}`]: true }},'input',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }